"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Direction = void 0;
exports.reducer = reducer;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _debug = _interopRequireDefault(require("debug"));
var _utils = require("./utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var log = (0, _debug.default)('exchange:search:reducer');
var Direction = exports.Direction = /*#__PURE__*/function (Direction) {
  Direction[Direction["Next"] = 1] = "Next";
  Direction[Direction["Previous"] = -1] = "Previous";
  return Direction;
}({});
var getCurrentResultPath = function getCurrentResultPath(results, isCurrentPath) {
  var _results$find;
  return (_results$find = results.find(function (_ref) {
    var path = _ref.path;
    return isCurrentPath(path);
  })) === null || _results$find === void 0 ? void 0 : _results$find.path;
};
function reducer(state, action) {
  log('processing action', action.type);
  switch (action.type) {
    case 'SEARCH_TERM_CHANGED':
      {
        var highlightedElements = state.highlightedElements;
        (0, _utils.cleanWrappedElements)(highlightedElements);
        log('highlighted elements being cleared', highlightedElements);
        return _objectSpread(_objectSpread({}, state), {}, {
          term: action.term,
          resultPaths: [],
          pageMatches: [],
          customMatches: [],
          emptyResults: false
        });
      }
    case 'SEARCH_STARTED':
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: true
      });
    case 'SEARCH_STOPPED':
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false
      });
    case 'SEARCH_FINISHED':
      {
        var _action$data = action.data,
          pageMatches = _action$data.pageMatches,
          customMatches = _action$data.customMatches,
          pagesFromStore = _action$data.pagesFromStore,
          isCurrentPath = _action$data.isCurrentPath;
        var resultPaths = (0, _utils.getResultPaths)(pagesFromStore, pageMatches, customMatches);
        log('got results paths', {
          pageMatches: pageMatches,
          customMatches: customMatches,
          pagesFromStore: pagesFromStore,
          isCurrentPath: isCurrentPath,
          resultPaths: resultPaths
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          loading: false,
          pageMatches: pageMatches,
          customMatches: customMatches,
          resultPaths: resultPaths,
          emptyResults: resultPaths.length === 0,
          currentResultPath: getCurrentResultPath(resultPaths, isCurrentPath)
        });
      }
    case 'MOVE_TO_MATCH':
      {
        var _state$currentMatch = state.currentMatch,
          currentMatch = _state$currentMatch === void 0 ? -1 : _state$currentMatch,
          _resultPaths = state.resultPaths,
          currentResultPath = state.currentResultPath,
          currentTotalMatches = state.currentTotalMatches,
          _highlightedElements = state.highlightedElements;
        var direction = action.direction;
        var nextResultPath = currentResultPath;
        var nextMatch = currentMatch + direction;
        var nextTotalMatches = currentTotalMatches;
        log('moving to next match', {
          currentMatch: currentMatch,
          resultPaths: _resultPaths,
          currentResultPath: currentResultPath,
          currentTotalMatches: currentTotalMatches,
          highlightedElements: _highlightedElements,
          nextMatch: nextMatch,
          nextTotalMatches: nextTotalMatches,
          nextResultPath: nextResultPath
        });
        var currentResultIndex = _resultPaths.findIndex(function (_ref2) {
          var path = _ref2.path;
          return path === currentResultPath;
        });

        // when having only one result and loops
        if ((nextMatch < 1 || nextMatch > currentTotalMatches) && _resultPaths.length === 1 && currentResultPath) {
          nextMatch = nextMatch < 1 ? currentTotalMatches : 1;
          (0, _utils.handleHighlight)(nextMatch, _highlightedElements);
        }

        // if should change path
        else if (nextMatch < 1 || nextMatch > currentTotalMatches) {
          var nextIndex = (currentResultIndex + direction) % _resultPaths.length;
          var nextResult = nextIndex < 0 ? _resultPaths[_resultPaths.length - 1] : _resultPaths[nextIndex];
          nextResultPath = nextResult.path;
          nextMatch = undefined;
          nextTotalMatches = undefined;
        }

        // proceed to highlight next result
        else {
          (0, _utils.handleHighlight)(nextMatch, _highlightedElements);
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          currentMatch: nextMatch,
          currentTotalMatches: nextTotalMatches,
          startFromFirstMatch: direction === Direction.Next,
          currentResultPath: nextResultPath
        });
      }
    case 'HIGHLIGHT_MATCHES':
      {
        var term = state.term,
          startFromFirstMatch = state.startFromFirstMatch,
          _currentResultPath = state.currentResultPath,
          _resultPaths2 = state.resultPaths;
        var _action$data2 = action.data,
          container = _action$data2.container,
          _isCurrentPath = _action$data2.isCurrentPath;
        var _highlightedElements2 = (0, _utils.wrapTerm)(container, term);
        var _currentTotalMatches = _highlightedElements2.length || undefined;
        var _currentMatch = startFromFirstMatch && _highlightedElements2.length ? 1 : _currentTotalMatches;
        (0, _utils.handleHighlight)(_currentMatch, _highlightedElements2);
        log('highlighting matches', {
          term: term,
          startFromFirstMatch: startFromFirstMatch,
          currentResultPath: _currentResultPath,
          currentTotalMatches: _currentTotalMatches,
          currentMatch: _currentMatch,
          resultPaths: _resultPaths2
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          highlightedElements: _highlightedElements2,
          currentResultPath: _currentResultPath !== null && _currentResultPath !== void 0 ? _currentResultPath : getCurrentResultPath(_resultPaths2, _isCurrentPath),
          currentTotalMatches: _currentTotalMatches,
          currentMatch: _currentMatch
        });
      }
    case 'CLEAN_RESULTS':
      {
        var _highlightedElements3 = state.highlightedElements;
        log('cleaning highlighted elements', _highlightedElements3);
        if (_highlightedElements3.length === 0) {
          return state;
        }
        (0, _utils.cleanWrappedElements)(_highlightedElements3);
        return _objectSpread(_objectSpread({}, state), {}, {
          highlightedElements: []
        });
      }
    case 'RESULT_CLICKED':
      {
        log('result clicked', action.path);
        return _objectSpread(_objectSpread({}, state), {}, {
          currentResultPath: action.path,
          startFromFirstMatch: true
        });
      }
    default:
      throw new Error("Invalid search action: ".concat(action));
  }
}
//# sourceMappingURL=reducer.js.map